<template>
    <div>
        <div v-if="!carrito && !loading || carritoItems.length === 0" class="container-vacio">
            <b-col class="text-center">
                <h3>Tu cesta está vacía</h3>
                <p>Explora multitud de eventos y experiencias en nuestra página</p>
            </b-col>
        </div>

        <div v-else-if="carrito && !loading && carrito?.seconds_left" class="container">
            <b-row>
                <TimerEntradasComponent :secondsLeft="carrito?.seconds_left" />
            </b-row>
            <b-row>
                <b-col md="8" sm="12">
                    <SteepsComponent :active="active_tab" />
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8" sm="12">
                    <ListadoEntradasComponent
                        v-if="active_tab == 1"
                        :entradas="carritoItems"
                        @eliminarProducto="eliminarProducto"
                    />
                    <DatosPedidoComponent
                        ref="datosPedido"
                        :entradas="carritoItems"
                        v-if="active_tab == 2"
                        @continuar="guardarDatos"
                    />
                    <template v-if="redsys">
                        <div v-show="false" v-html="redsys"></div>
                    </template>
                </b-col>
                <b-col md="4" sm="12">
                    <ResumenCarritoComponent
                        v-if="active_tab !== 4"
                        :active_tab="active_tab"
                        :datosCompra="datosCompra"
                        :disabled="disabled"
                        :buttonTitle="buttonTitle"
                        @continuar="continuar"
                        @volver="volver"
                    />
                </b-col>
            </b-row>
        </div>

        <div class="col-12 text-center" style="height: 550px" v-if="loading">
            <LoaderComponent/>
        </div>
    </div>
</template>


<script>
    import TimerEntradasComponent from '@/components/common/carrito/TimerEntradasComponent';
    import SteepsComponent from '@/components/common/carrito/SteepsComponent';
    import ListadoEntradasComponent from '@/components/common/carrito/ListadoEntradasComponent.vue';
    import ResumenCarritoComponent from '@/components/common/carrito/ResumenCarritoComponent.vue';
    import DatosPedidoComponent from '@/components/frontend/carrito/DatosPedidoComponent.vue';

    export default {
        data() {
            return {
                active_tab: 1,
                datosCompra: {},
                redsys: null,
                disabled: false,
                loading: true,
            }
        },
        mounted(){
            this.$store.dispatch('USUARIO_CARRITO_ACTIVO', {filters:{ uuid: localStorage.getItem('uuid')}});
            this.calcularResumenEntradas()
        },
        watch: {
            carritoItems(newItems) {
                if (newItems && newItems.length > 0) {
                    this.calcularResumenEntradas();
                }
            }
        },
        methods: {
            continuar() {
                switch (this.active_tab) {
                    case 1:
                        this.active_tab++
                        break;

                    case 2:
                        this.$refs.datosPedido.terminar();
                        break;

                    case 3:
                        this.active_tab++
                        break;
            
                    default:
                        this.active_tab++
                        break;
                }            
            },
            calcularResumenEntradas() {
                this.datosCompra = {
                    totalEntradas : this.totalEntradas,
                    precio : this.precioTotalSinGastos,
                    gastosGestion : this.gastos,
                    totalPrecio : this.precioTotalConGastos
                }
                this.loading = false;
            },
            eliminarProducto(item_id) {
                const params = {
                    filters: { uuid: localStorage.getItem('uuid') },
                    cart_id: this.carrito?.id,
                    item_id: item_id
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.delete-items'), params).then(res => {
                    this.$toast.success('Entrada borrada correctamente');
                    this.$store.dispatch('USUARIO_CARRITO_ITEMS', { cart_id: this.carrito.id, filters:{ uuid: localStorage.getItem('uuid') }})
                        .then(() => {
                            if (this.carritoItems.length === 0) {
                                this.$store.dispatch('USUARIO_CARRITO_DELETE', { cart_id: this.carrito.id, filters: { uuid: localStorage.getItem('uuid') }});
                            }
                        });
                }).catch(err => {
                    console.error('Error actualizando carrito online:', err);
                });
            },
            guardarDatos(datos_compra, datos_entradas) {
                this.disabled = true;

                const params = {
                    filters: { 
                        uuid: localStorage.getItem('uuid') 
                    },
                    cart_id: this.carrito?.id,
                    datos_compradores: datos_compra,
                    items: datos_entradas
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.guardar-datos'), params).then(res => {
                    this.redsys = res.data.formulario;
                    setTimeout(() => {
                        document.getElementById('btn-pagar').click();
                    }, 500);
                }).catch(err => {
                    console.error('Error actualizando carrito online:', err);
                }).finally(() => {
                    this.disabled = false;
                });
            },
            volver() {
                return this.active_tab--;
            }
        },
        computed: {
            uuid() {
                return localStorage.getItem('uuid');
            },
            carrito() {
                return this.$store.getters.getCarritoActivoOnline;
            },
            carritoItems() {
                return this.$store.getters.getCarritoItemsOnline;
            },
            buttonTitle() {
                let title = 'Continuar';

                switch (this.active_tab) {
                    case 1:
                        title = 'carrito.continuar_compra';
                        break;
                    case 2:
                        title = 'carrito.continuar_compra';
                        break
                    case 3:
                        title = 'carrito.finalizar_compra';
                        break
                    case 4:
                        title = 'carrito.compra_finalizada';
                        break
                }

                return title;
            },
            totalEntradas() {
                if (this.carritoItems?.length > 0) {
                    return this.carritoItems.reduce((total, evento) => {
                        const totalItemsEvento = evento.items.reduce((suma, item) => {
                            return suma + item.units;
                        }, 0);
                        return total + totalItemsEvento;
                    }, 0);
                }

                return 0;
            },
            precioTotalSinGastos() {
                if (this.carritoItems?.length > 0) {
                    return this.carritoItems.reduce((total, evento) => {
                        const totalPrecioEvento = evento.items.reduce((suma, item) => {
                            const descuento = item.descuento ? (1 - (item.descuento / 100)) : 1;
                            const precioConDescuento = (item.entrada.precio ?? item.entrada.price) * descuento;

                            return suma + (item.units * precioConDescuento);
                        }, 0);
                        return total + totalPrecioEvento;
                    }, 0);
                }

                return 0;
            },
            gastos() {
                if (this.carritoItems?.length > 0) {
                    return this.carritoItems.reduce((total, evento) => {
                        const totalGastosEvento = evento.items.reduce((suma, item) => {
                            if (!item.entrada.price_management_interno) {
                                return suma + item.entrada.price_management;
                            }
                        
                            return 0;
                        }, 0);
                        return total + totalGastosEvento;
                    }, 0);
                }

                return 0;
            },
            precioTotalConGastos() {
                var importe = this.precioTotalSinGastos;

                if(this.gastos > 0) {
                    importe += this.gastos;
                }

                return importe;
            }
        },
        components: {
            TimerEntradasComponent, SteepsComponent, ListadoEntradasComponent, ResumenCarritoComponent, DatosPedidoComponent
        }
    }
</script>

<style scoped>
.container {
    padding-top: 15px;
    line-height: 1.3;
    font-family: "Oswald", s;
}
.container-vacio {
    line-height: 1.3;
    font-family: "Oswald", sans-serif;
    text-align: center;
    padding: 12rem 2rem; 
}

@media (min-width: 768px) {
    .container-vacio {
        padding: 12rem 5rem;
    }
}
</style>